import { Alert, Link } from '@mui/material'

const HISTORY_DETAILS_SUFFIX =
  'tab to check status, success and failure counts, and error details.'

/**
 * Upload tab alert; success messages include a link that switches to Upload History.
 */
const UploadImportStatusAlert = ({
  severity,
  onClose,
  onViewUploadHistory,
  children,
  showHistoryLink = false,
}) => {
  const linkVisible = showHistoryLink && severity === 'success' && onViewUploadHistory

  return (
    <Alert severity={severity} sx={{ mb: 3 }} onClose={onClose}>
      {children}
      {linkVisible && (
        <>
          {' '}
          Open the{' '}
          <Link
            component="button"
            type="button"
            variant="body2"
            onClick={onViewUploadHistory}
            sx={{
              color: 'inherit',
              fontWeight: 700,
              textDecoration: 'underline',
              verticalAlign: 'baseline',
            }}
          >
            Upload History
          </Link>{' '}
          {HISTORY_DETAILS_SUFFIX}
        </>
      )}
    </Alert>
  )
}

export default UploadImportStatusAlert
